import "../k";
import { LEVELS } from "../data";
import { addButton } from "../things/button";
import { goTransition } from "../util/goTransition";

scene("levelIntro", (levelIndex: number) => {
  const level = LEVELS[levelIndex];

  const backButton = addButton("back", [pos(100, 100), "backButton"]);
  backButton.onClick(() => {
    goTransition("levelSelect");
  });

  add([
    text(level.name, {
      size: 64,
      font: "rumeur",
      width: width() * 0.6,
      align: "left",
    }),
    pos(width() / 2, height() / 2 - 200),
    anchor("center"),
    color(Color.BLACK),
  ]);

  if (level.intro && level.intro.text) {
    add([
      text(level.intro.text, {
        size: 32,
        font: "rumeur",
        width: width() * 0.6,
        align: "left",
        lineSpacing: 10,
      }),
      pos(width() / 2, height() / 2 - 140),
      anchor("top"),
      color(Color.BLACK),
    ]);
  }

  addButton("button", [
    pos(width() / 2, height() / 2 + 200),
    {
      textContents: "Start!",
    },
    "start-button",
  ]).onClick(() => {
    go("quiz", levelIndex);
  });
});
